import { Col } from "antd";
import { QC_VALIDATIONS } from "../../constants/Actions";
import { useEffect, useState } from "react";
import "status-indicator/styles.css";
import { DEVICE_STATUS } from "../../constants/OppContants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const StatusAnimationComponent = ({
  isQCRunning,
  currentDevice,
  deviceDefaultStatus,
  deviceStatus,
  isTriggered,
  handledActionFailed,
  handledActionComplete,
}) => {
  const [statusMap, setStatusMap] = useState([]);

  // default  & current value
  useEffect(() => {
    let status = deviceDefaultStatus ?? [];
    if (deviceStatus) {
      status = deviceStatus;
    }
    updateStatusMap(status);
  }, [deviceStatus, deviceDefaultStatus]);

  useEffect(() => {
    if (statusMap && statusMap.length > 0) {
      checkHandleActionFailed();
    }
  }, [statusMap]);

  const updateStatusMap = (status) => {
    let finalStatusMap = QC_VALIDATIONS.map((obj1) => {
      // Find the matching object from object2
      const obj2 = status.find((obj) => obj.actionId === obj1.id);

      // If a matching object is found, merge their properties
      return obj2 ? { ...obj1, ...obj2 } : { ...obj1 };
    });

    if (JSON.stringify(finalStatusMap) !== JSON.stringify(statusMap)) {
      setStatusMap(finalStatusMap);
    }
  };

  const checkHandleActionFailed = () => {
    statusMap.map((actionData) => {
      if (
        actionData.id === "DISPLAY_MESSAGE" ||
        actionData.actionId === "DISPLAY_MESSAGE"
      ) {
        if (actionData.status) {
          if (
            actionData.status.toUpperCase() ===
            DEVICE_STATUS.SUCCESS.toUpperCase()
          ) {
            handledActionComplete();
          } else {
            handledActionFailed();
          }
        }
      }
    });
  };

  return (
    <div
      key={"status_key_" + currentDevice}
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {statusMap.map((actionData, index) => {
        if (actionData.hide) {
          return <></>;
        }

        let statusIndicatorProps = {};
        switch (actionData.status?.toUpperCase()) {
          case DEVICE_STATUS.SUCCESS.toUpperCase():
            statusIndicatorProps.positive = true;
            break;
          case DEVICE_STATUS.FAILURE.toUpperCase():
            statusIndicatorProps.negative = true;
            break;
          case DEVICE_STATUS.TIMEOUT.toUpperCase():
          case DEVICE_STATUS.PAUSED.toUpperCase():
            statusIndicatorProps.intermediary = true;
            break;
          default:
            if (
              index !== 0 &&
              statusMap.length >= index + 1 &&
              statusMap[index - 1].status &&
              !statusMap[index + 1].status
            ) {
              statusIndicatorProps.active = true;
              if (isQCRunning) statusIndicatorProps.pulse = true;
            } else if (
              index === 0 &&
              statusMap &&
              statusMap[index].status === null &&
              isTriggered
            ) {
              statusIndicatorProps.active = true;
              if (isQCRunning) statusIndicatorProps.pulse = true;
            }
            break;
        }

        return (
          <Col style={{ flexDirection: "column" }} key={"index_" + index}>
            {actionData?.summary ? (
              <OverlayTrigger
                key={"index_info-tooltip" + index}
                overlay={
                  <Tooltip id="tooltip-top" style={{ fontSize: "12px" }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: actionData?.summary.replace(
                          /Validating/,
                          "Validated"
                        ),
                      }}
                    />
                  </Tooltip>
                }
              >
                <status-indicator {...statusIndicatorProps}></status-indicator>
              </OverlayTrigger>
            ) : (
              <status-indicator {...statusIndicatorProps}></status-indicator>
            )}
            <div className="summary-label" style={{ fontSize: "8px" }}>
              {actionData.displayTitle}
            </div>
          </Col>
        );
      })}
    </div>
  );
};

export default StatusAnimationComponent;
